interface MetadataOptions {
  title?: string;
  description?: string;
  keywords?: string[];
  ogImage?: string;
  ogUrl?: string;
  noIndex?: boolean;
}

export function buildMetadata(options: MetadataOptions = {}) {
  const {
    title = "OpenFarming",
    description = "OpenFarming - Modern Farming Solutions",
    keywords = ["farming", "agriculture", "openfarming"],
    ogImage = "/og-image.jpg",
    ogUrl = "https://openfarming.com",
    noIndex = false,
  } = options;

  return [
    { title: `${title} - OpenFarming` },
    { name: "description", content: description },
    { name: "keywords", content: keywords.join(", ") },
    // Open Graph / Facebook
    { property: "og:type", content: "website" },
    { property: "og:url", content: ogUrl },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:image", content: ogImage },
    // Twitter
    { property: "twitter:card", content: "summary_large_image" },
    { property: "twitter:url", content: ogUrl },
    { property: "twitter:title", content: title },
    { property: "twitter:description", content: description },
    { property: "twitter:image", content: ogImage },
    // Robots
    ...(noIndex ? [{ name: "robots", content: "noindex,nofollow" }] : []),
  ];
}
